import { put, takeLatest, call } from 'redux-saga/effects';
import Pagination from '../interfaces/common/pagination';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { PayloadAction } from '@reduxjs/toolkit';
import Paging from '../interfaces/common/paging';
import D365FeedbackStatus from '../interfaces/output/d365FeedbackStatus';
import D365FeedbackStatusApi from '../api/d365FeedbackStatus';
import { fetchD365FeedbackStatusByIdError, fetchD365FeedbackStatusByIdSuccess, fetchD365FeedbackStatusesError, fetchD365FeedbackStatusesSuccess } from '../reducers/d365FeedbackStatusReducer';

function* doFetchD365FeedbackStatus(action: PayloadAction<string>) {
    const d365FeedbackStatusId = action.payload;
    try {
        const response: D365FeedbackStatus = yield call(D365FeedbackStatusApi.fetchD365FeedbackStatusById, d365FeedbackStatusId);
        yield put(fetchD365FeedbackStatusByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchD365FeedbackStatusByIdError(error as HttpErrorResponse));
    }
}

function* doFetchD365FeedbackStatuses(action: PayloadAction<{ paging: Paging}>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<D365FeedbackStatus> = yield call(D365FeedbackStatusApi.fetchD365FeedbackStatuses, paging);
        yield put(fetchD365FeedbackStatusesSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchD365FeedbackStatusesError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('d365FeedbackStatus/fetchD365FeedbackStatusById', doFetchD365FeedbackStatus),
    takeLatest('d365FeedbackStatus/fetchD365FeedbackStatuses', doFetchD365FeedbackStatuses)
];

